import http from './reddit'
// operator
export default {
  getOperatorlist: () => http.Get(`${http.url.Newcommon}/operlt`),           // 取得操作員列表
  opergpop: () => http.Get(`${http.url.Newcommon}/opergpop`),                // 取得操作員組選單
  getOperatorData: (id) => http.Get(`${http.url.Newcommon}/operupge/${id}`), // 取得該操作員資料
  addOperator: (data) => http.Post(`${http.url.Newcommon}/operad`, data),    // 新增操作員
  modifyOperator: (data) => http.Post(`${http.url.Newcommon}/operuppo`, data), // 修改操作員
  opersaene: (data) => http.Post(`${http.url.Newcommon}/opersaene`, data),
  opersalkl: (data) => http.Post(`${http.url.Newcommon}/opersalkl`, data),
  getOperatorLog: (id) => http.Get(`${http.url.Newcommon}/operlog/${id}`), // 取得該操作員日誌
}